import { render, staticRenderFns } from "./ChoixProjet.vue?vue&type=template&id=2d5b0af6&scoped=true"
import script from "./ChoixProjet.vue?vue&type=script&lang=js"
export * from "./ChoixProjet.vue?vue&type=script&lang=js"
import style0 from "./ChoixProjet.vue?vue&type=style&index=0&id=2d5b0af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b0af6",
  null
  
)

export default component.exports